import * as Scrivito from "scrivito";
import setLanguage from "^/utils/setLanguage";
import validityCheck from "../../utils/validityCheck";

const Page = Scrivito.connect(({ page }) => {
  setLanguage(page);

  return (
    <Scrivito.ContentTag
      className="page-content"
      tag="div"
      content={page}
      attribute="body"
      role="main"
    />
  );
});

const PageWithLifeTime = validityCheck(Page);
Scrivito.provideComponent("Page", PageWithLifeTime);
